import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { customFieldsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as customFieldsActions from 'actions/customFieldsActions';
import { withTranslation } from 'react-i18next';
import { CUSTOM_FIELDS_TYPES } from "./";


class CustomFieldEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		let custom_field = {
			name: '',
			type: '',
		}

		let isEdit = false;

		if (props.custom_field) {
			custom_field = props.custom_field;
			isEdit = true;
		}

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			custom_field
		};
	}

	handleChange = event => {
		const { custom_field } = this.state;

		this.setState({
			custom_field: {
				...custom_field,
				[event.target.id]: event.target.value
			},
		});
	}

	checkValidField = (name) => {
		return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
	}

	handleSubmit = async event => {
		event.preventDefault();

		this.setState({ isLoading: true });
		let response = '';
		const props = this.props;

		// if edit => update; else => new
		if (this.state.isEdit) {
			response = await customFieldsService.update(this.state.custom_field);
		}
		else {
			response = await customFieldsService.add(this.state.custom_field);
		}

		//console.log(response);

		if (response.ok) {
			this.setState({
				isLoading: false,
				errors: {},
			});
			toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
			if (typeof this.props.getAllCustomFields === "function") {
				await this.props.getAllCustomFields();
			}
			props.handleClose();
		}
		else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response)
			});
		}
	}

	render() {
		const { custom_field } = this.state;

		const TYPE_KEYS = { TEXT: "customFields.types.text", TEXT_AREA: "customFields.types.textArea", NUMBER: "customFields.types.number", DATE: "customFields.types.date" };
		const optionList = CUSTOM_FIELDS_TYPES.map((item, i) => {
			return (
				<option key={i} value={item.type}>{this.props.t(TYPE_KEYS[item.type] || item.type)}</option>
			)
		}, this);

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup className="form-group" controlId="name">
						<FormLabel>{this.props.t("customFields.form.name")} <span className="label-required">*</span></FormLabel>
						<FormControl
							type="text"
							value={custom_field.name}
							onChange={this.handleChange}
							placeholder={this.props.t("customFields.form.namePlaceholder")}
							isInvalid={this.checkValidField('name')}
						/>

						<FormControl.Feedback type="invalid">
							{this.state.errors.name}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup className="form-group" controlId="type">
						<FormLabel>{this.props.t("customFields.form.type")}</FormLabel>
						<FormControl
							onChange={this.handleChange}
							value={custom_field.type}
							isInvalid={this.checkValidField('type')}
							as="select">
							<option value="-1">{this.props.t("customFields.form.selectType")}</option>
							{optionList}
						</FormControl>

						<FormControl.Feedback type="invalid">
							{this.state.errors.type}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer">
					<button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">{this.props.t("common.cancel")}</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t("common.save")}
						loadingText={this.props.t("common.saving")}
					/>
				</div>
			</form>
		)
	}
}


const mapStateToProps = (reducers) => {
	return reducers.customFieldsReducer;
};


export default connect(mapStateToProps, customFieldsActions)(withTranslation()(CustomFieldEdit))
